
	import { defineComponent, computed } from "vue"
  import { useRoute } from "vue-router"

	import LayoutUserMenu from "./UserMenu.vue"
  import LayoutMobileMenu from "./MobileMenu.vue"
  import LayoutHeaderMenu from "./HeaderMenu.vue"

  import { BaseMenuToggle } from "@/components/Base"

  import { MenuAlt3Icon } from "@heroicons/vue/solid"

  import store from "@/store"

	export default defineComponent({
		name: 'LayoutNav',

		components: {
			LayoutUserMenu,
      LayoutHeaderMenu,
      MenuAlt3Icon,
      BaseMenuToggle,
      LayoutMobileMenu
		},

    setup () {
      const route = useRoute()

      const isAuthenticated = computed(() => {
        return !!store.getters.getCurrentUserProfile?.email
      })

      return {
        isAuthenticated,
        route
      }
    }
	})
